import { useCallback, useEffect } from 'react';
import { axiosInterceptor } from 'views/pages/dashboard/CompanyProfile/IntegrateDiolog/DiologMenu/WebForm/interceptor';

export const usePostActivityLog = (module, isAuth = false) => {
    const postActivityLog = useCallback(async () => {
        try {
            const url = process.env.REACT_APP_WEBFORM_URL;
            let path = url + '/activityLog';
            if (isAuth) {
                path = path + '/auth';
            }
            const data = {
                module
            };
            await axiosInterceptor.post(path, data);
        } catch (error) {}
    }, [module]);

    useEffect(() => {
        postActivityLog();
    }, [postActivityLog]);
};
